import { adminGet, adminPost, adminDelete } from './useAdminCore';
export function useAdminDiscountActions() {
    function getQueuedRateActions(onSuccess) {
        adminGet('/Discounts/QueuedRateActions', onSuccess);
    }
    function addQueuedRateAction(action, onSuccess, onError) {
        adminPost('/Discounts/QueuedRateActions', action, onSuccess, onError ?? null);
    }
    function deleteQueuedRateAction(id, onSuccess) {
        adminDelete('/Discounts/QueuedRateActions/' + id, onSuccess);
    }
    return { getQueuedRateActions, addQueuedRateAction, deleteQueuedRateAction };
}
